module.exports = {"320707100":"青口镇","320707101":"柘汪镇","320707102":"石桥镇","320707103":"金山镇","320707104":"黑林镇","320707105":"厉庄镇","320707106":"海头镇","320707107":"塔山镇","320707108":"赣马镇","320707109":"班庄镇","320707110":"城头镇","320707112":"城西镇","320707114":"宋庄镇","320707115":"沙河镇","320707116":"墩尚镇","320707400":"沙河子园艺场","320707402":"赣榆海洋经济开发区","320707403":"赣榆经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320707.json
// module id = 887
// module chunks = 0